// Third party
import React from 'react';
import classNames from 'classnames';

// Components
import Tooltip from '../../../components/tooltips/Tooltip';

// Utils
import { formatMessage, formatLocalizedString } from '../../../../utils/i18n';
import ComparisonItemGroup from '@/types/comparison-item-group';

type Props = {
  group: ComparisonItemGroup;
  position: number;
  groupedLabel?: boolean;
  isItemToAdd: boolean;
  onAdd: (group: ComparisonItemGroup) => void;
  onRemove: (group: ComparisonItemGroup) => void;
  editGroups?: boolean;
};

class ComparisonItemGroupLabel extends React.Component<Props> {
  static defaultProps = {
    isItemToAdd: false,
  };

  renderLabel = (label: string) => {
    const { isItemToAdd } = this.props;
    return (
      <Tooltip className="comparison-item-group-text" message={isItemToAdd ? formatMessage('Comparison.Groups.Tooltips.AddToGroup') : label}>
        <span>{label}</span>
      </Tooltip>
    );
  };

  onLabelClick = (event: React.MouseEvent) => {
    event.stopPropagation();

    if (!this.props.editGroups || !this.props.isItemToAdd) {
      return;
    }

    if (this.props.onAdd) {
      this.props.onAdd(this.props.group);
    }
  };

  render() {
    const { group, position: index, groupedLabel, isItemToAdd, onRemove, editGroups } = this.props;

    return (
      <div
        data-private
        data-dd-privacy="mask"
        onClick={this.onLabelClick}
        className={classNames('comparison-item-group-label', {
          'is-grouped': groupedLabel,
          'no-remove-action': isItemToAdd || !editGroups,
          readonly: !editGroups,
        })}
        style={{
          backgroundColor: group.color,
          left: groupedLabel ? `${index > 10 ? 80 : index * 8}px` : 'inherit',
        }}
      >
        {this.renderLabel(formatLocalizedString(group.name))}

        {editGroups && !isItemToAdd && (
          <Tooltip message={formatMessage('Comparison.Groups.Tooltips.RemoveFromGroup')}>
            <button type="button" onClick={() => onRemove(group)}>
              <i className="icon-cross-thin" />
            </button>
          </Tooltip>
        )}
      </div>
    );
  }
}

export default ComparisonItemGroupLabel;
